import { useAdminGet } from '@reapitform/hooks'
import { AdminPdfTemplate, IResponseWithPagination, PdfTemplateField } from '../types'

export const ADMIN_PDF_TEMPLATES_QUERY_KEY = ['admin-pdf-templates']

/** Loads the PDF templates for a form version (`GET …/versions/{ref}/pdf-templates`). */
export const useAdminPdfTemplates = (formReferenceID?: string, versionReferenceID?: string) => {
  const [result, loading, errorString, refresh] = useAdminGet<IResponseWithPagination<AdminPdfTemplate>>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-templates?pageNumber=1&pageSize=100`,
    retry: false,
    queryKeys: [...ADMIN_PDF_TEMPLATES_QUERY_KEY, formReferenceID ?? '', versionReferenceID ?? ''],
    fetchWhenTrue: [Boolean(formReferenceID), Boolean(versionReferenceID)],
  })

  return { data: result?._embedded ?? [], loading, errorString, refresh }
}

/** Loads the extracted AcroForm fields for one template, on demand (`…/pdf-templates/{ref}/pdf-fields`). */
export const useAdminPdfTemplateFields = (
  formReferenceID?: string,
  versionReferenceID?: string,
  templateReferenceID?: string,
) => {
  const [data, loading, errorString, refresh] = useAdminGet<PdfTemplateField[]>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-templates/${templateReferenceID}/pdf-fields`,
    retry: false,
    queryKeys: [
      'admin-pdf-template-fields',
      formReferenceID ?? '',
      versionReferenceID ?? '',
      templateReferenceID ?? '',
    ],
    fetchWhenTrue: [Boolean(formReferenceID), Boolean(versionReferenceID), Boolean(templateReferenceID)],
  })

  return { data: data ?? [], loading, errorString, refresh }
}
